var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeader)?_c('Header'):_vm._e(),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }